<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="线索来源：" v-if="cueType==1">
        <el-select v-model="query.dataSource" placeholder="请选择" clearable size="small" @change="handleTechnical" filterable>
          <el-option label="名片" :value="1"></el-option>
          <el-option label="APP业务录入" :value="2"></el-option>
          <el-option label="后台录入" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户状态：">
        <el-select v-model="query.customerStatus" placeholder="请选择" clearable size="small" @change="handleTechnical" filterable>
          <el-option label="已激活" :value="1"></el-option>
          <el-option label="未激活" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="意向度：">
        <el-select v-model="query.intentionality" placeholder="请选择" clearable size="small" @change="handleTechnical" filterable>
          <el-option label="高" :value="1"></el-option>
          <el-option label="中" :value="2"></el-option>
          <el-option label="低" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加入时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import userApi from '@/api/user'
export default {
  props: ['cueType'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        type: undefined
      },
    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      this.query.createdTimeStart = this.dateTime && this.dateTime.length > 0 ? `${this.dateTime[0]}` : undefined
      this.query.createdTimeEnd = this.dateTime && this.dateTime.length > 0 ? `${this.dateTime[1]}` : undefined
      this.query.cueType=this.cueType*1
      return this.$common.confirm('是否确认导出')
        .then(() => userApi.exportExcels(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>
